import React, { FunctionComponent, memo } from 'react'

import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

interface Props {
  path: string
  linkText: string
  onClick?: () => void
  linkIcon: React.ComponentType
}

export const NavigationLink: FunctionComponent<Props> = memo(({ onClick, path, linkText, linkIcon: LinkIcon }: Props) => (
  <StyledLink className={({ isActive }) => (isActive ? 'active' : '')} to={path} onClick={onClick}>
    <IconWrapper>
      <LinkIcon />
    </IconWrapper>
    <LinkText>{linkText}</LinkText>
  </StyledLink>
))

const LinkText = styled.span`
  width: 100%;
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fonts.fontWeightNormal};
  font-family: ${({ theme }) => theme.fonts.textFont};
  line-height: 1.5em;
  color: ${({ theme }) => theme.colors.greyLight};
  transition: all 0.3s ease 0s;
  margin-left: ${({ theme }) => theme.space.S20};
  white-space: nowrap;
`
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;

  svg {
    overflow: visible;
    height: 24px;

    path,
    text {
      fill: ${({ theme }) => theme.colors.greyLight};
    }
  }
`
const StyledLink = styled(NavLink)`
  position: relative;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.space.S20};
  transition: all 0.3s ease 0s;

  &.active {
    border-right: 2px solid ${({ theme }) => theme.colors.violet};

    &:hover,
    ${IconWrapper} {
      svg {
        path,
        text {
          fill: ${({ theme }) => theme.colors.label};
        }
      }
    }

    ${LinkText} {
      color: ${({ theme }) => theme.colors.heading};
      font-weight: ${({ theme }) => theme.fonts.fontWeightBold};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.statusViolet};

    svg {
      path,
      text {
        fill: ${({ theme }) => theme.colors.grey};
      }
    }

    ${LinkText} {
      color: ${({ theme }) => theme.colors.heading};
    }
  }
`

NavigationLink.displayName = 'NavigationLink'
